var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type == 'image')?_c('img',_vm._g({attrs:{"src":_vm.imgSrc,"width":_vm.width,"alt":"Local Loot®"}},_vm.$listeners)):_c('span',_vm._g({},_vm.$listeners),[_vm._v(" Local Loot"),_c('sup',[_vm._v("®")])])}
var staticRenderFns = []

export { render, staticRenderFns }